import pkg from '../../package.json'

const getVersion = () => (import.meta.env.MODE === 'test' ? 'Test version' : pkg.version)

export const getWintlVersion = () =>
  import.meta.env.MODE === 'test' ? 'Test version' : pkg.dependencies['@weenat/wintl']

export const getClientVersion = () =>
  import.meta.env.MODE === 'test' ? 'Test version' : pkg.dependencies['@weenat/client']

export default getVersion
